import React, { useState, useMemo, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Badge,
  Alert,
  Input,
  FormGroup,
  Label,
  Collapse,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { getActiveColorStyle } from "../../../utils/colorUtils";
import classNames from "classnames";

const ApiPermissions = ({ activeColor = "secondary", shellThemeVariant = "1" }) => {
  const { t } = useTranslation();
  const [isLightTheme, setIsLightTheme] = useState(false);
  const [openAccordions, setOpenAccordions] = useState({});

  // Token'ı localStorage'dan oku
  const token = localStorage.getItem("token") || "";
  
  // Token'ı maskelenmiş şekilde göster (ilk 3 karakter + yıldızlar)
  const maskedToken = useMemo(() => {
    if (!token) return "";
    if (token.length <= 3) return token;
    return token.substring(0, 3) + "*".repeat(Math.min(token.length - 3, 50)); // Maksimum 50 yıldız göster
  }, [token]);

  const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);

  const toggleAccordion = (endpoint) => {
    setOpenAccordions(prev => ({
      ...prev,
      [endpoint]: !prev[endpoint]
    }));
  };

  useEffect(() => {
    const checkTheme = () => {
      setIsLightTheme(document.body.classList.contains('white-content'));
    };
    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const copyToken = () => {
    if (token) {
      copyToClipboard(token);
    }
  };

  const apiEndpoints = {
    inventory: {
      url: "https://api.dealertiq.com/api/all-inventory",
      method: "GET",
      description: "Tüm envanter verilerini getirir",
      response: `[
  {
    "id": 151,
    "createdAt": "2025-10-15T22:09:07.345Z",
    "updatedAt": "2025-10-20T11:02:50.929Z",
    "publishedAt": "2025-10-20T11:02:50.923Z",
    "locale": null,
    "stock_number": "M0026",
    "acquired_date": null,
    "price": 0,
    "mileage": "0",
    "images_count": "0",
    "description": "test",
    "body_trim": null,
    "bookkeeping": null,
    "asking_down": 0,
    "vehicle_expenses": 0,
    "floor_plan_expense": 0,
    "max_terms": 0,
    "repair_orders_count": 0,
    "repair_cost": 0,
    "inventory_status": 1,
    "location_change_date": null,
    "options": {
      "123": {},
      "standart_equipment": {
        "123": {
          "label": "123",
          "is_bold": false,
          "is_selected": false
        },
        "4wd/awd": {
          "label": "4WD/AWD",
          "is_bold": false,
          "is_selected": false
        },
        "abs_brakes": {
          "label": "ABS Brakes",
          "is_bold": false,
          "is_selected": false
        },
        "extra_breake": {
          "label": "extra breake",
          "is_bold": false,
          "is_selected": false
        }
      },
      "optional_equipment": {},
      "custom_equipment": {},
      "additional_specs": {}
    },
    "vin": "5XYPG4A50LG616002",
    "inventory_vehicle": {
      "id": 119,
      "createdAt": "2025-10-15T22:09:07.353Z",
      "updatedAt": "2025-10-16T12:42:06.250Z",
      "publishedAt": "2025-10-15T22:09:07.353Z",
      "locale": null,
      "vin": "5XYPG4A50LG616002",
      "new_used": "New",
      "year": "2020",
      "make": "Kia",
      "model": null,
      "trim": "2L, LX, S",
      "interior_trim": null,
      "exterior_color": null,
      "exterior_primary_color": null,
      "exterior_secondary_color": null,
      "body_style": null,
      "drive_type": null,
      "transmission": "Automatic",
      "engine": "3.3L 6 Cylinder",
      "fuel": null,
      "weight": null,
      "type": null,
      "condition": null,
      "actual_mileage": null,
      "actual_mileage_status": null,
      "notes": null,
      "user_defined": null,
      "tag_information": {
        "dealer_temp_tag": "",
        "dealer_temp_tag_date": "",
        "buyers_temp_tag": "",
        "buyers_temp_tag_date": "",
        "suppl_buyers_tag": "",
        "suppl_buyers_tag_date": "",
        "date_issued": ""
      },
      "additional_vehicle_info": {
        "user_defined": "",
        "plate_number": "",
        "plate_expiration_date": "",
        "inspection_expiration_date": "",
        "valuation_number": "",
        "emissions_number": "",
        "inspected_by_3rd_party": false,
        "recovery_functionality": "",
        "recovery_type": "",
        "recovery_esn": "",
        "gps_exp_date": ""
      },
      "additional_notes": null,
      "interior_color": null,
      "vehicle_status": {
        "id": 29,
        "status_name": "Sold",
        "status_key": "sold",
        "createdAt": "2025-09-22T22:49:22.773Z",
        "updatedAt": "2025-09-22T22:49:22.773Z",
        "publishedAt": "2025-09-22T22:49:22.774Z",
        "locale": null,
        "color": "#059669",
        "is_active": true
      }
    }
  }
]`,
    },
//     deals: {
//       url: "http://localhost:1337/api/all-deals",
//       method: "GET",
//       description: "Tüm anlaşma verilerini getirir",
//       response: `[
//   {
//     "id": 1,
//     "deal_number": "D001",
//     "customer_name": "John Doe",
//     "vehicle_id": 126,
//     "deal_amount": 25000,
//     "status": "active",
//     "created_at": "2025-01-01T00:00:00.000Z"
//   }
// ]`,
//     },
//     customers: {
//       url: "http://localhost:1337/api/all-customers",
//       method: "GET",
//       description: "Tüm müşteri verilerini getirir",
//       response: `[
//   {
//     "id": 1,
//     "first_name": "John",
//     "last_name": "Doe",
//     "email": "john.doe@example.com",
//     "phone": "+1234567890",
//     "address": "123 Main St",
//     "created_at": "2025-01-01T00:00:00.000Z"
//   }
// ]`,
//     },
//     reports: {
//       url: "http://localhost:1337/api/all-reports",
//       method: "GET",
//       description: "Tüm rapor verilerini getirir",
//       response: `[
//   {
//     "id": 1,
//     "report_name": "Monthly Sales Report",
//     "report_type": "sales",
//     "generated_at": "2025-01-01T00:00:00.000Z",
//     "data": {}
//   }
// ]`,
//     },
  };

  return (
    <div
      className={classNames("content api-permissions-page", {
        "theme2-admin-content-compact": shellThemeVariant === "2",
        "theme2-api-permissions-inset": shellThemeVariant === "2",
      })}
      style={{ minHeight: "80vh" }}
    >
      <style>
        {`
          .api-permissions-card-header.card-header {
            padding-top: 2px;
            padding-bottom: 0;
          }
          .api-permissions-card-header h2,
          .api-permissions-card-header h4 {
            font-size: 16px !important;
            margin-top: 10px;
            margin-bottom: 0;
            line-height: 1.2;
          }
          .api-permissions-page .card > .card-body {
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            padding-left: 15px;
            padding-right: 15px;
          }
        `}
      </style>
      <div style={{ width: '100%' }}>
        <div className="mt-0 w-100">
              <Row>
                <Col md="12">
                  {/* API Key Section */}
                  <Card className="mb-2">
                    <CardHeader className="api-permissions-card-header">
                      <h2 className="mb-0">{t("routes.apiPermissions")}</h2>
                    </CardHeader>
                    <CardBody>
                      <h5 className="mb-3">{t("apiPermissions.apiKey")}</h5>
                      <FormGroup >
                        {token ? (
                          <>
                            <div className="input-group align-items-center" style={{ height:"40px" }}>
                              <Input
                                type="text"
                                value={maskedToken}
                                readOnly
                                style={{ 
                                  fontFamily: "monospace",
                                  letterSpacing: "1px",
                                  height:"100%"
                                }}
                              />
                              <Button
                                onClick={copyToken}
                                
                                style={{  ...activeColorStyle,height:"100%" }}
                              >
                                {t("common.copy")}
                              </Button>
                            </div>
                            <small className="text-muted">
                              {t("apiPermissions.apiKeyDescription")}
                            </small>
                          </>
                        ) : (
                          <Alert color="warning">
                            {t("apiPermissions.noTokenFound")}
                          </Alert>
                        )}
                      </FormGroup>
                    </CardBody>
                  </Card>

                  <div className="accordion" id="apiEndpointsAccordion">
                    {Object.keys(apiEndpoints).map((endpoint) => (
                      <Card key={endpoint} className="mb-3">
                        <CardHeader 
                          style={{ 
                            cursor: 'pointer',
                            background: openAccordions[endpoint] ? activeColorStyle.background : 'transparent',
                            border: `1px solid ${activeColorStyle.borderColor}`,
                            padding:"10px",
                            marginBottom:"0px"
                          }}
                          onClick={() => toggleAccordion(endpoint)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <Badge 
                                style={{ 
                                  background: "green",
                                  color: "white", 
                                  padding: '0.5rem 1rem',
                                  fontSize: '12px',
                                  marginRight: '1rem'
                                }}
                              >
                                {apiEndpoints[endpoint].method}
                              </Badge>
                              <code 
                                style={{ fontSize: '14px' ,fontWeight:600, color: openAccordions[endpoint] ? 'white' : isLightTheme ? 'black' : 'white' }}
                              >
                                {apiEndpoints[endpoint].url}
                              </code>
                            </div>
                            <i 
                              className={`fas fa-chevron-${openAccordions[endpoint] ? 'up' : 'down'}`}
                              style={{ color: openAccordions[endpoint] ? 'white' : activeColorStyle.borderColor }}
                            />
                          </div>
                        </CardHeader>
                        <Collapse isOpen={openAccordions[endpoint]}>
                          <CardBody>
                            <div className="mb-4">
                              <p className="text-muted mb-3">
                              </p>
                              
                              <div className="mb-4">
                                <CardTitle>{t("apiPermissions.headers")}</CardTitle>
                                <div className={`${isLightTheme ? 'bg-light text-dark' : 'bg-dark text-light'} p-3 rounded`}>
                                  <code className={`${isLightTheme ? 'text-dark' : 'text-light'}`}>
                                    Authorization: Bearer {maskedToken}
                                  </code>
                                  <br />
                                  <code className={`${isLightTheme ? 'text-dark' : 'text-light'}`}>
                                    Content-Type: application/json
                                  </code>
                                </div>
                                <Button
                                  size="sm"
                                  className="mt-2"
                                  onClick={() => copyToClipboard(`Authorization: Bearer ${token}\nContent-Type: application/json`)}
                                >
                                  {t("common.copyHeaders")}
                                </Button>
                              </div>

                              <div className="mb-4">
                                <CardTitle >{t("apiPermissions.responseExample")}</CardTitle>
                                <div
                                  className={`${isLightTheme ? 'bg-light text-dark' : 'bg-dark text-light'} p-3 rounded`}
                                  style={{
                                    maxHeight: "400px",
                                    overflowY: "auto",
                                  }}
                                >
                                  <pre className="mb-0">
                                    <code>{apiEndpoints[endpoint].response}</code>
                                  </pre>
                                </div>
                                <Button
                                  size="sm"
                                  className="mt-2"
                                  onClick={() => copyToClipboard(apiEndpoints[endpoint].response)}
                                >
                                  {t("common.copyResponse")}
                                </Button>
                              </div>

                              <div className="mb-4">
                                <CardTitle>{t("apiPermissions.curlExample")}</CardTitle>
                                <div className={`${isLightTheme ? 'bg-light text-dark' : 'bg-dark text-light'} p-2 d-block mt-2 `}>
                                  <code className={`${isLightTheme ? 'text-dark' : 'text-light'}`}>
                                    curl -X {apiEndpoints[endpoint].method} \<br />
                                    &nbsp;&nbsp;{apiEndpoints[endpoint].url} \<br />
                                    &nbsp;&nbsp;-H "Authorization: Bearer {maskedToken}" \<br />
                                    &nbsp;&nbsp;-H "Content-Type: application/json"
                                  </code>
                                </div>
                              </div>
                            </div>
                          </CardBody>
                        </Collapse>
                      </Card>
                    ))}
                  </div>
                </Col>
              </Row>
        </div>
      </div>
    </div>
  );
};

export default ApiPermissions;
